module.exports = __webpack_public_path__ + "static/media/wall-green.89f2eed3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wall-green.png
// module id = 142
// module chunks = 0